import { AssignmentStore, MessageDialog, Store } from "@bryntum/schedulerpro";
import { SwivuProjectModel } from "../../bryntum-lib/models/SwivuProjectModel.jsx";
import { Assignment } from "../../bryntum-lib/models/Assignment.jsx";
import { Event } from "../../bryntum-lib/models/Event.jsx";
import { Contact } from "../../bryntum-lib/models/Contact.jsx";
import { KeyValueModel } from "../../bryntum-lib/models/KeyValueModel.jsx";
import { TaskIntegrationsModel } from "../../bryntum-lib/models/TaskIntegrationsModel.tsx";
import { PlanTaskAssignment } from "../../bryntum-lib/models/TaskAssignment.jsx";
import { SwivuTaskStore } from "../../bryntum-lib/stores/SwivuTaskStore.jsx";
import { SwivuEventStore } from "../../bryntum-lib/stores/SwivuEventStore.jsx";
import { SwivuGeneratedPlanEventStore } from "../../bryntum-lib/stores/SwivuPlanEventStore.jsx";
import { SwivuTagValuesStore } from "../../bryntum-lib/stores/SwivuTagValuesStore.jsx";
import { STORE_KEYS } from "../constants/StoreKeys.jsx";
import { SwivuTeamStore } from "../../bryntum-lib/stores/SwivuTeamStore.jsx";
import TimeRange from "../../bryntum-lib/models/TimeRange.jsx";
import { SwivuResourceStore } from "../../bryntum-lib/stores/SwivuResourceStore.jsx";
import { SwivuPlanResourceStore } from "../../bryntum-lib/stores/SwivuPlanResourceStore.jsx";
import { SwivuClientStore } from "../../bryntum-lib/stores/SwivuClientStore.jsx";
import { SwivuResourceTypeStore } from "../../bryntum-lib/stores/SwivuResourceTypeStore.jsx";
import { Board } from "../../bryntum-lib/models/Board.jsx";
import { ReminderStore } from "../../bryntum-lib/stores/reminder/ReminderStore.jsx";
import { ReminderRecipientStore } from "../../bryntum-lib/stores/reminder/ReminderRecipientStore.jsx";
import { BoardClientAgenda } from "../../bryntum-lib/models/BoardClientAgenda.jsx";
import { ClientAgenda } from "../../bryntum-lib/models/ClientAgenda.jsx";
import {BoardPreferences} from "../../bryntum-lib/models/BoardPreferences.jsx";
import { ResourceTagValues } from "../../bryntum-lib/models/ResourceTagValues.jsx";
import { TagValue } from "../../bryntum-lib/models/TagValue.jsx";
import {TaskBudget} from "../../bryntum-lib/models/TaskBudget.jsx";
import {Checklist} from "../../bryntum-lib/models/Checklist.tsx";
import {ChecklistItems} from "../../bryntum-lib/models/ChecklistItems.tsx";
import {SwivuStoreArchiveMixin} from "../../bryntum-lib/stores/mixins/SwivuStoreArchiveMixin.jsx";
import {ResourceAgenda} from "../../bryntum-lib/models/ResourceAgenda.jsx";
import {NotifyeeBoardUser} from "../../bryntum-lib/models/NotifyeeBoardUser.jsx";
import {BoardNote} from "../../bryntum-lib/models/BoardNote.tsx";
import {SwivuStoreCanViewMixin} from "../../bryntum-lib/stores/mixins/SwivuStoreCanViewMixin.jsx";
import { User } from "../../bryntum-lib/models/User.jsx";
import {ClientContact} from "../../bryntum-lib/models/ClientContact.jsx";
import {ResourceContact} from "../../bryntum-lib/models/ResourceContact.jsx";
import {TaskContact} from "../../bryntum-lib/models/TaskContact.jsx";
import {UserContact} from "../../bryntum-lib/models/UserContact.jsx";
import {EntityContactStore} from "../../bryntum-lib/stores/EntityContactStore.jsx";
import {ViewFolder} from "../../bryntum-lib/models/ViewFolder.jsx";
import {SwivuSortedGroupersMixin} from "../../bryntum-lib/stores/mixins/SwivuSortedGroupersMixin.jsx";
import { NotifyPreferences } from "../../bryntum-lib/models/NotifyPrefrences.jsx";
import { NonWorkingTime } from "../../bryntum-lib/models/NonWorkingTime.jsx";
import ViewsStore from "../../bryntum-lib/stores/ViewsStore.jsx";
import { TaskPlanningDates } from "../../bryntum-lib/models/TaskPlanningDates.jsx";
import { SwivuStoreAssignedCanViewMixin } from "../../bryntum-lib/stores/mixins/SwivuStoreAssignedCanViewMixin.jsx";
import { PERSISTENCE_STATE_KEYS } from "../constants/PersistenceStateKeys.jsx";
import { checkUserEmailAndRole, transformSwivuGridRecords } from "../utils/utils.jsx";
import { incentiveCanViewFilterFn, incentivePointCanViewFilterFn } from "../utils/incentiveUtils.jsx";
import { ImportBatch } from "../../bryntum-lib/models/ImportBatch.jsx";
import { isNegativeField } from "../utils/budgetUtils.jsx";
import { triggerSwivuAssistUpdate } from "../../modern/components/editors/swivuAssist/SwivuAssistEditor";
import { getSwivuAssitText } from "../../network/network.jsx";
import { OutcomeIncentive } from "../../bryntum-lib/models/OutcomeIncentive.jsx";
import { IncentivePoint } from "../../bryntum-lib/models/IncentivePoint.jsx";
import { SwivuIncentivePointsStore } from "../../bryntum-lib/stores/SwivuIncentivePointsStore.jsx";
import { SwivuOutcomeIncentiveStore } from "../../bryntum-lib/stores/SwivuOutcomeIncentiveStore.jsx";
import { IncentiveBoardPreference } from "../../bryntum-lib/models/IncentiveBoardPreference.jsx";
import { OutcomeIncentiveCondition } from "../../bryntum-lib/models/OutcomeIncentiveCondition.jsx";
import { ResourceIntegrationsModel } from "@/bryntum-lib/models/ResourceIntegrationsModel";
import { ClientIntegrationsModel } from "@/bryntum-lib/models/ClientIntegrationsModel";
import { SwivuSpotIncentiveStore } from "../../bryntum-lib/stores/SwivuSpotIncentiveStore.jsx";
import { SpotIncentive } from "../../bryntum-lib/models/SpotIncentive.jsx";
import { IncentiveTagCategory } from "../../bryntum-lib/models/IncentiveTagCategory.jsx";
import { IncentiveTag } from "../../bryntum-lib/models/IncentiveTag.jsx";
import { IncentivePointTag } from "../../bryntum-lib/models/IncentivePointTag.jsx";
import { SwivuIncentivePointTagsStore } from "../../bryntum-lib/stores/SwivuIncentivePointTagsStore.jsx";
import { ContextCard } from "../../bryntum-lib/models/ContextCard";
import { SwivuContextCardStore } from "../../bryntum-lib/stores/SwivuContextCardStore.jsx";
import { FieldAdvisorCard } from "../../bryntum-lib/models/FieldAdvisorCard";
import { SwivuFieldAdvisorCardStore } from "../../bryntum-lib/stores/SwivuFieldAdvisorCardStore.jsx";
import { Insights } from "../../bryntum-lib/models/Insights.tsx";
import { MarketingTag } from "../../bryntum-lib/models/MarketingTag";
import { MarketingAsset } from "../../bryntum-lib/models/MarketingAsset";
import { ProblemSolutionTagMap } from "../../bryntum-lib/models/ProblemSolutionTagMap";
import { PromotePromptCard } from "../../bryntum-lib/models/PromotePromptCard";
import { MarketingWorkFile } from "../../bryntum-lib/models/MarketingWorkFile";
import { MarketingWorkFileCard } from "../../bryntum-lib/models/MarketingWorkFileCard";
import { MarketingPage } from "../../bryntum-lib/models/MarketingPage";
import { MarketingDocument } from "../../bryntum-lib/models/MarketingDocument";
import { Site } from "../../bryntum-lib/models/Site";
import { Submission } from "../../bryntum-lib/models/Submission";
import { SubmissionFile } from "../../bryntum-lib/models/SubmissionFile";
import { Location } from "../../bryntum-lib/models/Location";
import { BoardContext } from "../../bryntum-lib/models/BoardContext";
import { BoardContextGroup } from "../../bryntum-lib/models/BoardContextGroup";
import { BoardContextStatement } from "../../bryntum-lib/models/BoardContextStatement";

// Use this with caution, every call will likely cause view refresh (see more info below)
/*function reapplyEventSortOnChange({ source, action, changes }) {
  if (
    action === "add" || action === "remove" ||
    // Filter out update events if they do not change any fields valuable to sorter
    (action === "update" && ('startDate' in changes || 'endDate' in changes || 'duration' in changes || 'task' in changes))
    ) {
    // Reapply sorter on the resource store only, event store overlapping sorter would be used automatically
    source.resourceStore.sort();
  }
}*/

// When adding event project will delay change events related to add and update actions leading to two sorts (and refreshes)
// performed. Possible ways around are: 1. combine change event listener with dataReady event on the project. or 2. buffer
// listeners to invoke them asynchronously (which is what we do here).
// const bufferedReapplySorter = FunctionHelper.createBuffered(reapplyEventSortOnChange, 0);

const projectFactory = (user) => {
  //#region Instantiate additional stores
  const extraBoardIntegrationsStore = new Store({
    id: STORE_KEYS.extraBoardIntegrationsStore,
    storeId: STORE_KEYS.extraBoardIntegrationsStore,
    modelClass: KeyValueModel,
    useSparseIndex: false,
  });

  const taskTagValues = new SwivuTagValuesStore({
    id: STORE_KEYS.taskTagValuesStore,
    storeId: STORE_KEYS.taskTagValuesStore,
    modelClass: TagValue,
    useSparseIndex: true,
  });
  const clientTagValues = new SwivuTagValuesStore({
    id: STORE_KEYS.clientTagValuesStore,
    storeId: STORE_KEYS.clientTagValuesStore,
    modelClass: TagValue,
    useSparseIndex: true,
  });
  const resourceTagValues = new SwivuTagValuesStore({
    id: STORE_KEYS.resourceTagValuesStore,
    storeId: STORE_KEYS.resourceTagValuesStore,
    modelClass: ResourceTagValues,
    useSparseIndex: true,
  });
  const contactTagValues = new SwivuTagValuesStore({
    id: STORE_KEYS.contactTagValuesStore,
    storeId: STORE_KEYS.contactTagValuesStore,
    modelClass: TagValue,
    useSparseIndex: true,
  });
  const teamStore = new SwivuTeamStore();
  const resourceTypeStore = new SwivuResourceTypeStore();

  const taskIntegrationsStore = new Store({
    id: STORE_KEYS.taskIntegrationsStore,
    storeId: STORE_KEYS.taskIntegrationsStore,
    modelClass: TaskIntegrationsModel,
    useSparseIndex: false,
  });

  const resourceIntegrationsStore = new Store({
    id: STORE_KEYS.resourceIntegrationsStore,
    storeId: STORE_KEYS.resourceIntegrationsStore,
    modelClass: ResourceIntegrationsModel,
    useSparseIndex: false,
  });

  const clientIntegrationsStore = new Store({
    id: STORE_KEYS.clientIntegrationsStore,
    storeId: STORE_KEYS.clientIntegrationsStore,
    modelClass: ClientIntegrationsModel,
    useSparseIndex: false,
  });

  // contact stores
  const contactsStore = new (SwivuSortedGroupersMixin(Store))({
    id: STORE_KEYS.contactStore,
    storeId: STORE_KEYS.contactStore,
    modelClass: Contact,
    useSparseIndex: false,
  });

  const boardUsersStore = new Store({
    id: STORE_KEYS.boardUserStore,
    storeId: STORE_KEYS.boardUserStore,
    modelClass: User,
    [STORE_KEYS.contactStore]: contactsStore,
    useSparseIndex: false,
    swivuCurrentUser: user,
    listeners: {
      update: ({ record, changes }) => {
        checkUserEmailAndRole(boardUsersStore.project, user, record, changes);
      },
      remove: ({ records }) => {
        const isCurrentUserRemoved = records.find((record) => record.userId === user.id);
        if (isCurrentUserRemoved) {
          MessageDialog.alert({
            title: "User Removed",
            message: `Your are now removed from this board. For support, please contact the administrator.`
          }).then(() => {
            window.location.reload();
          })
        }
      }
    }
  });

  const boardNotesStore = new (SwivuStoreCanViewMixin(Store, user))({
    id: STORE_KEYS.boardNotesStore,
    storeId: STORE_KEYS.boardNotesStore,
    modelClass: BoardNote,
    useSparseIndex: true,
  })

  const clientsStore = new SwivuClientStore({
    [STORE_KEYS.boardUserStore]: boardUsersStore,
    useSparseIndex: true,
  });

  const userPreferencesStore = new Store({
    id: STORE_KEYS.userPreferencesStore,
    storeId: STORE_KEYS.userPreferencesStore,
    modelClass: KeyValueModel,
    useSparseIndex: false,
  });

  const taskBudgetStore = new (SwivuStoreArchiveMixin(Store))({
    id: STORE_KEYS.taskBudgetStore,
    storeId: STORE_KEYS.taskBudgetStore,
    modelClass: TaskBudget,
    useSparseIndex: false,
    listeners: {
      update: ({ record, changes }) => {
        const updatedFields = Object.keys(changes);
        const canTriggerRerenderInTasks = updatedFields.some((field) => isNegativeField(field));
        if (canTriggerRerenderInTasks && record.budgetTasks && record.budgetTasks.length) {
          record.budgetTasks.forEach(task => task.reRender = !task.reRender)
        }
      }
    }
  });

  const extraTaskStore = new SwivuTaskStore({
    [STORE_KEYS.boardUserStore]: boardUsersStore,
    [STORE_KEYS.taskBudgetStore]: taskBudgetStore,
    useSparseIndex: true,
  });

  const boardStore = new Store({
    id: STORE_KEYS.boardStore,
    storeId: STORE_KEYS.boardStore,
    modelClass: Board,
    useSparseIndex: false,
  });

  const boardClientAgendaStore = new Store({
    id: STORE_KEYS.boardClientAgendaStore,
    storeId: STORE_KEYS.boardClientAgendaStore,
    modelClass: BoardClientAgenda,
    useSparseIndex: false,
  });

  const clientAgendaStore = new Store({
    id: STORE_KEYS.clientAgendaStore,
    storeId: STORE_KEYS.clientAgendaStore,
    modelClass: ClientAgenda,
    useSparseIndex: false,
  });

  //#region Plan view stores
  // Plan view is a scheduler pro which shows tasks in rows and events in the timeline. Idieally
  // we would just use extraTaskStore for rows, but it wouldn't work for several reasons:
  // 1. row store should extend ResourceStore class
  // 2. row store model should extend ResourceModel class
  // 3. scheduler pro would add resource and event store under own project control, replacing real one
  // In order to avoid that we need to craft special resource store which would get data from the
  // extraTaskStore. Unfortunately, due to #2 we cannot just chain the store because that would create
  // instance of the same class and would use instances of Task model for records.
  // Solution:
  // 1. create scheduler pro resource store
  // 2. use resource model extension for model class
  // 3. connect two stores via event system to sync changes (similar to chained store)

  // Stores with prefix `plan` are proxies for stores monitored by the main app project - extraTaskStore,
  // taskEventStore and taskAssignmentStore. Changes are propagated from main stores to proxy stores.
  const planAssignmentStore = new AssignmentStore({
    id: "swivuPlanAssignmentStore",
    modelClass: PlanTaskAssignment
  });

  const planResourceStore = new SwivuPlanResourceStore();

  const planEventStore = new SwivuGeneratedPlanEventStore();

  const resourceStore = new SwivuResourceStore({
    [STORE_KEYS.boardUserStore]: boardUsersStore,
    useSparseIndex: true,
  });

  const reminderStore = new ReminderStore({
    [STORE_KEYS.taskStore]: extraTaskStore,
    [STORE_KEYS.resourceStore]: resourceStore,
    [STORE_KEYS.clientStore]: clientsStore,
    [STORE_KEYS.boardUserStore]: boardUsersStore,
    useSparseIndex: true,
  });

  const reminderRecipientStore = new ReminderRecipientStore({
    [STORE_KEYS.boardUserStore]: boardUsersStore,
    [STORE_KEYS.reminderStore]: reminderStore,
    useSparseIndex: false,
  });

  const boardPreferencesStore = new Store({
    id: STORE_KEYS.boardPreferencesStore,
    storeId: STORE_KEYS.boardPreferencesStore,
    modelClass: BoardPreferences,
    useSparseIndex: false,
    listeners: {
      change: ({ action, records, source }) => {
        if (["add", "update"].includes(action)) {
          const budgetLabelRecord = records.find((record) => record.key === PERSISTENCE_STATE_KEYS.budgetLabel);
          const swivuAssistLastUpdatedRecord = records.find((record) => record.key === PERSISTENCE_STATE_KEYS.swivuAssistLastUpdated);
          if (budgetLabelRecord) {
            const project = source.project;
            const taskWithBudgets = project.extraTaskStore.query((record) => record.budgetId && !record.isLinked, true);
            project.beginBatch();
            taskWithBudgets.forEach((budgetTask) => budgetTask.reRender = !budgetTask.reRender);
            project.endBatch();
          }
          /** This condition is need for other users, when board owner is click on update button of assist.
           The updated text of assist will not be triggered for other users on same board.
           */
          if (swivuAssistLastUpdatedRecord) {
            getSwivuAssitText(swivuAssistLastUpdatedRecord.board).then((resp) => {
              transformSwivuGridRecords(resp.data);
              triggerSwivuAssistUpdate();
            })
          }
        }
      }
    }
  })

  const checklistStore = new (SwivuStoreAssignedCanViewMixin(SwivuStoreArchiveMixin(Store), boardUsersStore))({
    modelClass: Checklist,
    id: STORE_KEYS.checklistStore,
    storeId: STORE_KEYS.checklistStore,
    // useSparseIndex: true,
  });

  const checklistItemStore = new Store({
    modelClass: ChecklistItems,
    checklistStore,
    id: STORE_KEYS.checklistItemStore,
    storeId: STORE_KEYS.checklistItemStore,
    // Todo: When enabled the sparse index on this store the duplicate checklist feature breaks in console, see useSwivuChecklist.js -> duplicateChecklistRecord function catch handler called on error
    // useSparseIndex: true,
    listeners: {
      update: ({ record }) => {
        // Bug: Checklist record instance is not mapped via relations
        // Re-triggering getters in checklist to update state in checklist grids
        const project = record.firstStore?.crudManager;
        if (project) {
          const checklistRecord = project.checklistStore.getById(record.checklistId);
          if (checklistRecord) {
            checklistRecord.reRender = !checklistRecord.reRender
          }
        }

      }
    }
  })

  const resourceAgendaStore = new Store({
    modelClass: ResourceAgenda,
    id: STORE_KEYS.resourceAgendaStore,
    storeId: STORE_KEYS.resourceAgendaStore
  })

  const notfiyeeBoardUserStore = new Store({
    modelClass: NotifyeeBoardUser,
    id: STORE_KEYS.notifyeeBoardUsers,
    storeId: STORE_KEYS.notifyeeBoardUsers,
    useSparseIndex: false,
  })

  const taskContactsStore = new EntityContactStore({
    id: STORE_KEYS.taskContactStore,
    storeId: STORE_KEYS.taskContactStore,
    modelClass: TaskContact,
    [STORE_KEYS.taskStore]: extraTaskStore,
    [STORE_KEYS.contactStore]: contactsStore,
    useSparseIndex: true,
  });

  const resourceContactsStore = new EntityContactStore({
    id: STORE_KEYS.resourceContactStore,
    storeId: STORE_KEYS.resourceContactStore,
    modelClass: ResourceContact,
    [STORE_KEYS.resourceStore]: resourceStore,
    [STORE_KEYS.contactStore]: contactsStore,
    useSparseIndex: true,
  });

  const clientContactsStore = new EntityContactStore({
    id: STORE_KEYS.clientContactStore,
    storeId: STORE_KEYS.clientContactStore,
    modelClass: ClientContact,
    [STORE_KEYS.clientStore]: clientsStore,
    [STORE_KEYS.contactStore]: contactsStore,
    useSparseIndex: true,
  });

  const userContactsStore = new EntityContactStore({
    id: STORE_KEYS.userContactStore,
    storeId: STORE_KEYS.userContactStore,
    modelClass: UserContact,
    [STORE_KEYS.boardUserStore]: boardUsersStore,
    [STORE_KEYS.contactStore]: contactsStore,
    useSparseIndex: true,
  });

  const viewsFolderStore = new Store({
    id: STORE_KEYS.viewsFolderStore,
    storeId: STORE_KEYS.viewsFolderStore,
    modelClass: ViewFolder,
    useSparseIndex: true,
  });

  const viewsStore = new ViewsStore({
    [STORE_KEYS.viewsFolderStore]: viewsFolderStore,
    useSparseIndex: true,
  });

  const notifyPreferenceStore = new Store({
    id: STORE_KEYS.notifyPreferenceStore,
    storeId: STORE_KEYS.notifyPreferenceStore,
    modelClass: NotifyPreferences,
    useSparseIndex: true,
  });

  const nonWorkingTimeStore = new Store({
    // storeId is deprecated in behalf of id
    id: STORE_KEYS.nonWorkingTimeStore,
    modelClass: NonWorkingTime,
    useSparseIndex: false,
  })

  const taskPlanningDatesStore = new Store({
    modelClass: TaskPlanningDates,
    id: STORE_KEYS.taskPlanningDatesStore,
    storeId: STORE_KEYS.taskPlanningDatesStore,
    [STORE_KEYS.taskStore]: extraTaskStore,
    useSparseIndex: false,
  })

  const importBatchStore = new Store({
    modelClass: ImportBatch,
    id: STORE_KEYS.importBatchStore,
    storeId: STORE_KEYS.importBatchStore,
    useSparseIndex: false,
  })

  const outcomeIncentiveStore = new (SwivuStoreCanViewMixin(SwivuOutcomeIncentiveStore, user, "canView", incentiveCanViewFilterFn))({
    modelClass: OutcomeIncentive,
    id: STORE_KEYS.outcomeIncentiveStore,
    storeId: STORE_KEYS.outcomeIncentiveStore,
    useSparseIndex: false,
  })

  const incentivePointTagsStore = new SwivuIncentivePointTagsStore({
    id: STORE_KEYS.incentivePointTagsStore,
    storeId: STORE_KEYS.incentivePointTagsStore,
    modelClass: IncentivePointTag,
    useSparseIndex: false,
  })

  const incentivePointsStore = new (SwivuStoreCanViewMixin(SwivuIncentivePointsStore, user, "canView", incentivePointCanViewFilterFn))({
    id: STORE_KEYS.incentivePointsStore,
    storeId: STORE_KEYS.incentivePointsStore,
    modelClass: IncentivePoint,
    [STORE_KEYS.taskStore]: extraTaskStore,
    [STORE_KEYS.incentivePointTagsStore]: incentivePointTagsStore,
    useSparseIndex: false,
  })

  const incentiveBoardPreferencesStore = new Store({
    id: STORE_KEYS.incentiveBoardPreferencesStore,
    storeId: STORE_KEYS.incentiveBoardPreferencesStore,
    modelClass: IncentiveBoardPreference,
    useSparseIndex: false,
  })

  const outcomeIncentiveConditionsStore = new (SwivuStoreCanViewMixin(Store, user, "canView", incentiveCanViewFilterFn))({
    id: STORE_KEYS.outcomeIncentiveConditionsStore,
    storeId: STORE_KEYS.outcomeIncentiveConditionsStore,
    modelClass: OutcomeIncentiveCondition,
    useSparseIndex: true,
  })

  const spotIncentiveStore = new (SwivuStoreCanViewMixin(SwivuSpotIncentiveStore, user, "canView", incentiveCanViewFilterFn))({
    modelClass: SpotIncentive,
    id: STORE_KEYS.spotIncentiveStore,
    storeId: STORE_KEYS.spotIncentiveStore,
    useSparseIndex: false,
  })

  const incentiveTagCategoryStore = new Store({
    id: STORE_KEYS.incentiveTagCategoryStore,
    storeId: STORE_KEYS.incentiveTagCategoryStore,
    modelClass: IncentiveTagCategory,
    useSparseIndex: false,
  })

  const incentiveTagsStore = new Store({
    id: STORE_KEYS.incentiveTagsStore,
    storeId: STORE_KEYS.incentiveTagsStore,
    modelClass: IncentiveTag,
    useSparseIndex: false,
  })

  const contextCardsStore = new SwivuContextCardStore({
    id: STORE_KEYS.contextCardsStore,
    storeId: STORE_KEYS.contextCardsStore,
    modelClass: ContextCard,
    useSparseIndex: false,
  })

  const fieldAdvisorCardsStore = new SwivuFieldAdvisorCardStore({
    id: STORE_KEYS.fieldAdvisorCardsStore,
    storeId: STORE_KEYS.fieldAdvisorCardsStore,
    modelClass: FieldAdvisorCard,
    useSparseIndex: false,
  })

  const insightsStore = new Store({
    id: STORE_KEYS.insightsStore,
    storeId: STORE_KEYS.insightsStore,
    modelClass: Insights,
    useSparseIndex: false,
  })

  const marketingTagStore = new Store({
    id: STORE_KEYS.marketingTagStore,
    storeId: STORE_KEYS.marketingTagStore,
    modelClass: MarketingTag,
    useSparseIndex: false,
  })

  const marketingAssetStore = new Store({
    id: STORE_KEYS.marketingAssetStore,
    storeId: STORE_KEYS.marketingAssetStore,
    modelClass: MarketingAsset,
    useSparseIndex: false,
  })

  const problemSolutionTagMapStore = new Store({
    id: STORE_KEYS.problemSolutionTagMapStore,
    storeId: STORE_KEYS.problemSolutionTagMapStore,
    modelClass: ProblemSolutionTagMap,
    useSparseIndex: false,
  })

  const promotePromptCardStore = new Store({
    id: STORE_KEYS.promotePromptCardStore,
    storeId: STORE_KEYS.promotePromptCardStore,
    modelClass: PromotePromptCard,
    useSparseIndex: false,
  })

  const marketingWorkfileStore = new (SwivuStoreArchiveMixin(Store))({
    id: STORE_KEYS.marketingWorkfileStore,
    storeId: STORE_KEYS.marketingWorkfileStore,
    modelClass: MarketingWorkFile,
    useSparseIndex: false,
  })

  const marketingWorkfileCardStore = new Store({
    id: STORE_KEYS.marketingWorkfileCardStore,
    storeId: STORE_KEYS.marketingWorkfileCardStore,
    modelClass: MarketingWorkFileCard,
    useSparseIndex: false,
  })

  const marketingPageStore = new Store({
    id: STORE_KEYS.marketingPageStore,
    storeId: STORE_KEYS.marketingPageStore,
    modelClass: MarketingPage,
    useSparseIndex: false,
  })

  const marketingDocumentStore = new Store({
    id: STORE_KEYS.marketingDocumentStore,
    storeId: STORE_KEYS.marketingDocumentStore,
    modelClass: MarketingDocument,
    useSparseIndex: false,
  })

  const sitesStore = new Store({
    id: STORE_KEYS.sitesStore,
    storeId: STORE_KEYS.sitesStore,
    modelClass: Site,
    useSparseIndex: false,
  })

  const submissionsStore = new Store({
    id: STORE_KEYS.submissionsStore,
    storeId: STORE_KEYS.submissionsStore,
    modelClass: Submission,
    useSparseIndex: false,
  })

  const submissionfilesStore = new Store({
    id: STORE_KEYS.submissionfilesStore,
    storeId: STORE_KEYS.submissionfilesStore,
    modelClass: SubmissionFile,
    useSparseIndex: false,
  })

  const locationStore = new Store({
    id: STORE_KEYS.locationStore,
    storeId: STORE_KEYS.locationStore,
    modelClass: Location,
    useSparseIndex: false,
  })

  const boardContextStore = new Store({
    id: STORE_KEYS.boardContextStore,
    storeId: STORE_KEYS.boardContextStore,
    modelClass: BoardContext,
    useSparseIndex: false,
  })

  const boardContextGroupStore = new Store({
    id: STORE_KEYS.boardContextGroupStore,
    storeId: STORE_KEYS.boardContextGroupStore,
    modelClass: BoardContextGroup,
    useSparseIndex: false,
  })

  const boardContextStatementStore = new Store({
    id: STORE_KEYS.boardContextStatementStore,
    storeId: STORE_KEYS.boardContextStatementStore,
    modelClass: BoardContextStatement,
    useSparseIndex: false,
  })

  //#endregion

  //#endregion

  const getExtraStores = () => {
    return {
      boardNotesStore,
      extraTaskStore,
      clientTagValues,
      taskTagValues,
      resourceTagValues,
      contactTagValues,
      clientsStore,
      contactsStore,
      userPreferencesStore,
      planEventStore,
      planResourceStore,
      planAssignmentStore,
      extraBoardIntegrationsStore,
      taskIntegrationsStore,
      resourceIntegrationsStore,
      clientIntegrationsStore,
      teamStore,
      resourceTypeStore,
      boardStore,
      boardClientAgendaStore,
      clientAgendaStore,
      // -----
      reminderStore,
      reminderRecipientStore,
      boardPreferencesStore,
      taskBudgetStore,
      checklistStore,
      checklistItemStore,
      resourceAgendaStore,
      boardUsersStore,
      notfiyeeBoardUserStore,
      taskContactsStore,
      resourceContactsStore,
      clientContactsStore,
      userContactsStore,
      viewsFolderStore,
      viewsStore,
      notifyPreferenceStore,
      nonWorkingTimeStore,
      taskPlanningDatesStore,
      importBatchStore,
      outcomeIncentiveStore,
      incentivePointTagsStore,
      incentivePointsStore,
      incentiveBoardPreferencesStore,
      outcomeIncentiveConditionsStore,
      spotIncentiveStore,
      incentiveTagCategoryStore,
      incentiveTagsStore,
      contextCardsStore,
      fieldAdvisorCardsStore,
      insightsStore,
      marketingTagStore,
      marketingAssetStore,
      problemSolutionTagMapStore,
      promotePromptCardStore,
      marketingWorkfileStore,
      marketingWorkfileCardStore,
      marketingPageStore,
      marketingDocumentStore,
      sitesStore,
      submissionsStore,
      submissionfilesStore,
      locationStore,
      boardContextStore,
      boardContextGroupStore,
      boardContextStatementStore,
    };
  };

  const projectConfig = {
    isContextProject: true,
    autoLoad: false, // loaded in bryntum-context.js
    autoSync: true,
    autoSyncTimeout: 2000, // Debounces network calls on changes in the data in stores; Making this change to not exhaust project with rapid changes.
    eventModelClass: Event,
    assignmentModelClass: Assignment,
    eventStoreClass: SwivuEventStore,
    resourceStore,
    assignmentStore: {
      storeId: "assignments"
    },
    timeRangeStore: {
      modelClass: TimeRange
    },
    // Configure transport to include credentials (cookies) in requests for Bryntum 7
    transport: {
      load: {
        credentials: 'include'
      },
      sync: {
        credentials: 'include'
      }
    },
    crudStores: [
      // By default, project applies sync responses to the stores in the same order as the stores were initially loaded.
      // If someone updates the order of the crud stores, it will affect the sequence in which sync responses are applied.
      // Todo: Set a specific sequence for applying sync responses to the stores.
      // https://bryntum.com/products/schedulerpro/docs/api/SchedulerPro/model/ProjectModel#config-syncApplySequence
      // Processing reminder and reminder recipients first because we need updated reminder instances in main entities.
      reminderRecipientStore,
      reminderStore,
      boardNotesStore,
      extraTaskStore,
      clientTagValues,
      taskTagValues,
      resourceTagValues,
      contactTagValues,
      clientsStore,
      taskIntegrationsStore,
      resourceIntegrationsStore,
      clientIntegrationsStore,
      contactsStore,
      userPreferencesStore,
      teamStore,
      resourceTypeStore,
      boardStore,
      boardClientAgendaStore,
      clientAgendaStore,
      // When applying changes to record code takes a special path if an engine-related field
      // is changed. In case of assignment store it is `event`. Triggered code path changes id
      // silently and doesn't update idMap on the store. That prevents project from clearing
      // `store.added` storage properly and results in a folowing sync request with wrong id.
      // This is why first we update entity stores and after that - relation stores (dependency,
      // assignment)
      extraBoardIntegrationsStore,
      // -----
      boardPreferencesStore,
      taskBudgetStore,
      checklistStore,
      checklistItemStore,
      resourceAgendaStore,
      notfiyeeBoardUserStore,
      boardUsersStore,
      taskContactsStore,
      resourceContactsStore,
      clientContactsStore,
      userContactsStore,
      viewsStore,
      viewsFolderStore,
      notifyPreferenceStore,
      nonWorkingTimeStore,
      taskPlanningDatesStore,
      importBatchStore,
      outcomeIncentiveStore,
      incentivePointTagsStore,
      incentivePointsStore,
      incentiveBoardPreferencesStore,
      outcomeIncentiveConditionsStore,
      spotIncentiveStore,
      incentiveTagCategoryStore,
      incentiveTagsStore,
      contextCardsStore,
      fieldAdvisorCardsStore,
      insightsStore,
      marketingTagStore,
      marketingAssetStore,
      problemSolutionTagMapStore,
      promotePromptCardStore,
      marketingWorkfileStore,
      marketingWorkfileCardStore,
      marketingPageStore,
      marketingDocumentStore,
      sitesStore,
      submissionsStore,
      submissionfilesStore,
      locationStore,
      boardContextStore,
      boardContextGroupStore,
      boardContextStatementStore,
    ],

    validateResponse: true
  };

  const planProjectConfig = {
    eventStore: planEventStore,
    resourceStore: planResourceStore,
    assignmentStore: planAssignmentStore,
    timeRangeStore: {
      modelClass: TimeRange
    },
    // Configure transport to include credentials (cookies) in requests for Bryntum 7
    transport: {
      load: {
        fetchOptions: {
          credentials: 'include'
        }
      },
      sync: {
        fetchOptions: {
          credentials: 'include'
        }
      }
    }
  };

  projectConfig.crudStores.forEach((crudStore) => {
    // In bryntum 6+ they enabled useRawData value to default true, which means when data is loaded in response of ajax request
    // the data will be used as it is without any cloning or conversion but that adds another invalid behavior
    // see issue link => https://forum.bryntum.com/viewtopic.php?t=29942
    crudStore.useRawData = false;

  })

  const project = new SwivuProjectModel(projectConfig);
  // For some reason project doesn't expose extra stores if they're provided
  // to the config. Applying keys directly to it.
  Object.assign(project, getExtraStores());

  project.on({
    load() {
      planEventStore.populatePlanEventStore();
      /* This is a util function in the store mixins to apply the actions of the mixins to the store, we used to rely on the store.applyState() method to initiate the actions of the mixins but the applyState method is not called on react based UI & using some other life cycle method like afterConstruct causes issues if we use data from someother store like the SwivuStoreAssignedCanViewMixin which uses data from the board user store.*/
      project.crudStores.forEach((crudStore) => {
        crudStore.store.swivuPerformMixinActions?.();
      });
    },
    once: true
  });

  project.extraTaskStore.on({
    remove({ records }) {
      records.forEach((r) => {
        // remove events associated with the removed task
        this.eventStore.remove(this.eventStore.query((e) => e.taskId === r.id));
      });
    },
    thisObj: project
  });

  const planProject = new SwivuProjectModel(planProjectConfig);
  Object.assign(planProject, getExtraStores());

  // Add a link between projects to simplify lookups
  planProject.mainProject = project;
  setupStoreRelations(project);

  return { project, planProject, extraStores: getExtraStores() };
};

function setupStoreRelations(project) {
  const {
    eventStore,
    assignmentStore,
    extraTaskStore,
    planResourceStore,
    planEventStore,
    clientTagValues,
    resourceTagValues,
    contactTagValues,
    taskTagValues,
    teamStore,
    resourceTypeStore,
    boardUsersStore,
    viewsStore,
    boardPreferencesStore,
    taskPlanningDatesStore,
    importBatchStore,
    outcomeIncentiveStore,
    incentiveTagsStore,
    incentivePointsStore,
    incentiveBoardPreferencesStore,
    outcomeIncentiveConditionsStore,
    spotIncentiveStore,
    incentiveTagCategoryStore,
    contextCardsStore,
    fieldAdvisorCardsStore,
    insightsStore,
    marketingTagStore,
    marketingAssetStore,
    problemSolutionTagMapStore,
    promotePromptCardStore,
    marketingWorkfileStore,
    marketingWorkfileCardStore,
    marketingPageStore,
    marketingDocumentStore,
    sitesStore,
    submissionsStore,
    submissionfilesStore,
    locationStore,
    boardContextStore,
    boardContextGroupStore,
    boardContextStatementStore,
  } = project;

  extraTaskStore.connectSwivuStore(planResourceStore);

  planEventStore.bindEventStore(eventStore);
  planEventStore.bindAssignmentStore(assignmentStore);
  planEventStore.bindPlanningDateStore(taskPlanningDatesStore);

  // Setup listener on the assignment store to update assigned resources on the plan view
  assignmentStore.on({
    change({ action, record }) {
      if (action === "update") {
        const planEvent = planEventStore.getById(record.eventId);

        if (planEvent) {
          // Todo: Remove it if not being used
          planEvent.resetTaskEventResource();
        }
      }
    }
  });

  clientTagValues.project = project;
  resourceTagValues.project = project;
  contactTagValues.project = project;
  taskTagValues.project = project;
  teamStore.project = project;
  resourceTypeStore.project = project;
  boardUsersStore.project = project;
  viewsStore.project = project;
  extraTaskStore.project = project;
  boardPreferencesStore.project = project;
  importBatchStore.project = project
  outcomeIncentiveStore.project = project;
  incentivePointsStore.project = project;
  incentiveBoardPreferencesStore.project = project;
  outcomeIncentiveConditionsStore.project = project;
  spotIncentiveStore.project = project;
  incentiveTagCategoryStore.project = project;
  incentiveTagsStore.project = project;
  contextCardsStore.project = project;
  fieldAdvisorCardsStore.project = project;
  insightsStore.project = project;
  marketingTagStore.project = project;
  marketingAssetStore.project = project;
  problemSolutionTagMapStore.project = project;
  promotePromptCardStore.project = project;
  marketingWorkfileStore.project = project;
  marketingWorkfileCardStore.project = project;
  marketingPageStore.project = project;
  marketingDocumentStore.project = project;
  sitesStore.project = project;
  submissionsStore.project = project;
  submissionfilesStore.project = project;
  locationStore.project = project;
  boardContextStore.project = project;
  boardContextGroupStore.project = project;
  boardContextStatementStore.project = project;
}

export default projectFactory;
